import { type NavMenuHierarchy, type NavMenuHierarchyL1 } from '../nav-v2/NavMenuHierarchy'

// 4 sidebar section headers in the v3 NavigationBar IA, per Figma 8504:30873.
// Each section groups N L1 NavGroups; the renderer emits NavSection (header) +
// L1 NavGroups + NavDivider (between sections) inside SidebarContent.
export enum NavSectionV3 {
  Global = 'Global',
  Commerce = 'Commerce',
  Operations = 'Operations',
  Developer = 'Developer',
}

// Single source of truth for the i18n key per section. Renderer reads via
// NAV_SECTION_TITLES[section.id] — no display strings live on the section itself.
export const NAV_SECTION_TITLES: Record<NavSectionV3, string> = {
  [NavSectionV3.Global]: 'navV3.section.global.title',
  [NavSectionV3.Commerce]: 'navV3.section.commerce.title',
  [NavSectionV3.Operations]: 'navV3.section.operations.title',
  [NavSectionV3.Developer]: 'navV3.section.developer.title',
}

export type NavMenuHierarchySectionV3 = {
  id: NavSectionV3
  l1s: NavMenuHierarchyL1[]
}

// v3 swaps NavMenuHierarchy's flat `hierarchy: L1[]` for `sections: Section[]`.
// Keeps the rest of the metadata (navBarColor, type, homeRoute) unchanged.
export type NavMenuHierarchyV3 = Omit<NavMenuHierarchy, 'hierarchy'> & {
  sections: NavMenuHierarchySectionV3[]
}
